
<mat-form-field appearance="fill">
  <mat-label>{{label}}</mat-label>
  <mat-select (selectionChange)="onSelectionChange($event)" [value]="value" [multiple]="multiple">
    <mat-option *ngFor="let option of options" [value]="option">
      {{option}}
    </mat-option>
  </mat-select>
</mat-form-field>
